<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Checkout</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/checkout">Checkout</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card" v-if="useWallet()">
            <div class="card-content products">
              <div class="card-body">
                <div class="media d-flex">
                  <div class="align-self-top">
                    <i class="icon-wallet icon-opacity font-large-4 float-left"></i>
                  </div>
                  <div class="media-body text-right align-self-bottom">
                    <span class="d-block mb-1 font-medium-1">Wallet Balance</span>
                    <h1 class="mb-0">R{{balance}}</h1><br />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-content cart">
              <div class="card-body">
                <div class="media d-flex">
                  <div class="align-self-top">
                    <i class="icon-basket icon-opacity font-large-4 float-left"></i>
                  </div>
                  <div class="media-body text-right align-self-bottom">
                    <span class="d-block mb-1 font-medium-1">Cart Balance</span>
                    <h1 class="mb-0">R{{cartBalanceComputed}}</h1><br />
                  </div>

                </div>
                <table class="table table-striped">
                  <tbody>
                    <tr v-for="item in cart" v-bind:key="item.id">
                      <td>{{item.label}} - R{{item.price}}<br />
                        <div v-if="item.additions">
                          <small v-for="addition in item.additions" v-bind:key="addition.id">{{addition.label}} - R{{addition.price}}, </small>
                          <small v-for="exclusion in item.exclusions" v-bind:key="exclusion.id">{{exclusion.label}} - R{{exclusion.price}}, </small>
                        </div>
                      </td>
                      <!--<td>R{{calculateItemPrice(item)}}</td>-->
                      <td><button type="button" class="btn btn-icon btn-danger" v-on:click="removeItem(item)"><i class="ft-x-circle"></i></button></td>
                    </tr>
                  </tbody>
                </table>
                <fieldset class="form-group">
                  <label for="notes">Order/Delivery Notes</label>
                  <textarea class="form-control" id="notes" v-model="notes" rows="3"></textarea>
                </fieldset>

                <button type="button" class="btn btn-danger btn-block" v-on:click="placeOrder">Place Order</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'checkout',
  data: function () {
    return {
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : [],
      cartBalance: 0,
      balance: this.calculateBalance(),
      notes: ''
    }
  },
  computed: {
    cartBalanceComputed () {
      var total = 0
      this.cart.forEach(function (item) {
        total = total + parseFloat(item.price)

        if (item.additions) {
          item.additions.forEach(function (addition) {
            total = total + parseFloat(addition.price)
          })
        }
      })
      return total.toFixed(2)
    }
  },
  methods: {
    calculateBalance: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.wallet_balance
    },
    /*
    calculateItemPrice: function (item) {
      var total = parseFloat(item.price)

      if (item.additions) {
        item.additions.forEach(function (addition) {
          total = total + parseFloat(addition.price)
        })
      }

      return total
    },
    */
    removeItem: function (item) {
      var newCart = []

      this.cart.forEach(function (cart) {
        if (cart.mealId !== item.mealId) {
          newCart.push(cart)
        }
      })

      this.cart = newCart
      window.localStorage.setItem('cart', JSON.stringify(newCart))
    },
    placeOrder: function () {
      var that = this
      var merchantId = window.localStorage.getItem('merchantId')
      var period = window.localStorage.getItem('period')
      var date = window.localStorage.getItem('date')

      var items = []
      this.cart.forEach(function (item) {
        items.push({
          menu_id: item.mealId,
          additions: item.additions,
          exclusions: item.exclusions
        })
      })

      // Reset the inclusions and exclusions because we might have added or removed something from the array
      var data = {
        period_id: period,
        date: date,
        note: this.notes,
        items: items,
        merchant_id: merchantId,
        token: localStorage.getItem('token')
      }

      if (window.localStorage.getItem('boardroomId') && window.localStorage.getItem('boardroomTime')) {
        data.time = window.localStorage.getItem('boardroomTime')
        data.boardroom = window.localStorage.getItem('boardroomId')
      }

      $.ajax({
        url: this.$config.apiUrl + 'canteenapp_orders/place',
        type: 'POST',
        data: data,
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        success: function (data) {
          var user = JSON.parse(window.localStorage.getItem('user'))
          user.wallet_balance = data.data.wallet_balance
          window.localStorage.setItem('user', JSON.stringify(user))
          window.localStorage.removeItem('cart')

          that.balance = data.data.wallet_balance

          swal({
            text: 'Order has been placed!',
            icon: 'success',
            title: 'Success',
            buttons: {
              cancel: {
                text: 'Order Again',
                value: 'order',
                visible: true,
                className: '',
                closeModal: true
              },
              confirm: {
                text: 'Logout',
                value: 'logout',
                visible: true,
                className: '',
                closeModal: true
              }
            }
          }).then(function (data) {
            if (data === 'logout') {
              localStorage.clear()
              that.$router.push('/login')
            } else if (data === 'order') {
              that.$router.push('/')
            }
          })
        },
        error: function (data) {
          console.log('ERROR DATA')
          console.log(data)
          swal('Error', data.responseJSON.meta.reason, 'error')
        }
      })
    },
    useWallet: function () {
      var output = false

      var user = JSON.parse(window.localStorage.getItem('user'))
      user.parent.company.merchants.forEach(function (merchant) {
        if (window.localStorage.getItem('merchantId') && merchant.id === window.localStorage.getItem('merchantId')) {
          if (merchant.use_wallet === 'Y') {
            output = true
          }
        }
      })

      return output
    }
  }
}
</script>

<style scoped>
.cart table {
  border:none;
  width:100%;
}
.cart td {
  padding:5px;
  vertical-align:middle;
}
</style>
